import {Api} from '@/api/Api';

export type LoginContext = {
  project_id: number;
  company_id: number;
};

export default class LoginContextAPI extends Api {
  consume(loginContext: string): Promise<LoginContext> {
    return this.post({
      url: `auth/login-contexts/${encodeURIComponent(loginContext)}/consume`,
      headers: [],
      body: JSON.stringify({}),
    })
      .then((response) => this.processResponse(response))
      .then((response) => response.data.attributes as LoginContext);
  }
}
